import { render } from "./gsrsu04010101.vue?vue&type=template&id=5108ba42&scoped=true"
import script from "./gsrsu04010101.vue?vue&type=script&lang=js"
export * from "./gsrsu04010101.vue?vue&type=script&lang=js"

import "./gsrsu04010101.vue?vue&type=style&index=0&id=5108ba42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5108ba42"]])

export default __exports__